import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/settings/quoting/playbooks/$playbookId/rules",
      params,
      replace: true,
    })
  },
})
